<template>
    <div>
        <b-modal
            id="terms-service-popup"
            title="Terms of Service"
            size="lg"
            hide-footer
            no-close-on-backdrop
        >
            <div id="style-3" class="scrollable">
                <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book.
                </p>
                <h3>1. Definitions</h3>
                <h4>A. Parties</h4>
                <ol type="1">
                    <li>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s.
                    </li>
                </ol>
                <h4>B. Content</h4>
                <ol type="1">
                    <li>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s.
                    </li>
                </ol>
                <h3>2. Using the Sites</h3>
                <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting, remaining
                    essentially unchanged. It was popularised in the 1960s with
                    the release of Letraset sheets containing Lorem Ipsum
                    passages, and more recently with desktop publishing software
                    like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
                <h4>Eligibility</h4>
                <p>
                    To access or use the Site, you must be 18 years or older and
                    have the requisite power and authority to enter into these
                    Terms.
                </p>
                <h4>Site Availability</h4>
                <p>
                    The Site may be modified, updated, interrupted, suspended or
                    discontinued at any time without notice or liability.
                </p>
                <h4>Communications from The Idenfo and other Users</h4>
                <p>
                    By creating an account, you agree to receive certain
                    communications in connection with the Site. For example, you
                    might receive notifications of new offers available on the
                    platform.
                </p>
                <h3>3. Restrictions</h3>
                <p>
                    While we encourage you to let us know if you believe another
                    user has violated the Terms, we reserve the right to
                    investigate and take appropriate action at our sole
                    discretion.
                </p>

                <ol type="1">
                    <li>Violate the Terms;</li>
                    <li>
                        Modify, adapt, appropriate, reproduce, distribute,
                        translate, create derivative works or adaptations of,
                        publicly display, sell, trade, or in any way exploit the
                        Site or Site Content (other than Your Content), except
                        as expressly authorized by The Idenfo;
                    </li>
                    <li>
                        Use any robot, spider, site search/retrieval
                        application, or other automated device, process or means
                        to access, retrieve, scrape, or index any portion of the
                        Site or any Site Content;
                    </li>
                    <li>
                        Reverse engineer any portion of the Site;
                    </li>
                    <li>
                        Remove or modify any copyright, trademark or other
                        proprietary rights notice that appears on any portion of
                        the Site or on any materials printed or copied from the
                        Site;
                    </li>
                    <li>
                        Record, process, or mine information about other users;
                    </li>
                    <li>
                        Access, retrieve or index any portion of the Site for
                        purposes of constructing or populating a searchable
                        database of business reviews;
                    </li>
                    <li>
                        Reformat or frame any portion of the Site;
                    </li>
                    <li>
                        Take any action that imposes, or may impose, in our sole
                        discretion, an unreasonable or disproportionately large
                        load on The Idenfo's technology infrastructure or
                        otherwise make excessive traffic demands of the Site;
                    </li>
                    <li>
                        Attempt to gain unauthorized access to the Site, user
                        accounts, computer systems or networks connected to the
                        Site through hacking, password mining or any other
                        means;
                    </li>
                    <li>
                        Use the Site or any Site Content to transmit any
                        computer viruses, worms, defects, Trojan horses or other
                        items of a destructive nature (collectively,
                        <b>"Viruses")</b>;
                    </li>
                    <li>
                        Use any device, software or routine that interferes with
                        the proper working of the Site, or otherwise attempt to
                        interfere with the proper working of the Site;
                    </li>
                    <li>
                        Use the Site to violate the security of any computer
                        network, crack passwords or security encryption codes;
                        disrupt or interfere with the security of, or otherwise
                        cause harm to, the Site or Site Content; or
                    </li>
                    <li>
                        Remove, circumvent, disable, damage or otherwise
                        interfere with any security-related features of the
                        Site, features that prevent or restrict the use or
                        copying of Site Content, or features that enforce
                        limitations on the use of the Site.
                    </li>
                </ol>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    },
    methods: {
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
    },
}
</script>
